import { motion } from 'framer-motion';
import { Fragment, useEffect, useState } from 'react';
import BottomSheet from '~/components/common/bottom-sheet';
import { Translate } from '~/i18n';
import { CitiesDropdownProps } from '.';
import styles from './styles.module.css';
import { CloseIconDark } from '~/svgs/common';

const MobileDropdown = ({ onChange, defaultValue, regions = [] }: CitiesDropdownProps) => {
   const [open, setOpen] = useState(false);
   const [selectedLabel, setSelectedLabel] = useState(
      regions.find(region => region.slug === defaultValue)
   );
   const onClick = () => {
      setOpen(prev => !prev);
   };
   const toggle = (current?: boolean) => setOpen(current || false);

   const onItemClicked = (href: string, element: HTMLLIElement, idx: number) => {
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
      onChange(href, element);
      // setSelected(element);
      setSelectedLabel(regions[idx]);
      setOpen(false);
   };

   useEffect(() => {
      setSelectedLabel(regions.find(city => city.slug === defaultValue));
   }, [regions, defaultValue]);

   return (
      <Fragment>
         <button
            onClick={onClick}
            type="button"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded={open ? 'true' : 'false'}
            className="shadow-none w-full py-3.5 flex justify-center items-center">
            {selectedLabel && (
               <div className="flex items-center justify-center">
                  <motion.span className="text-2xs xs:text-[15px] font-semibold ltr:ml-4 rtl:mr-4">
                     {selectedLabel.name}
                  </motion.span>
               </div>
            )}
            {!selectedLabel && (
               <Fragment>
                  <span className="text-2xs xs:text-[15px] font-semibold">
                     <Translate id="common:anywhere" />
                  </span>
               </Fragment>
            )}
         </button>
         <BottomSheet open={open} toggle={toggle}>
            <div className="px-4 mt-[21px] text-primary-color">
               <div className="flex">
                  <div className="text-center pb-[19px] flex-1 text-[17px]">
                     <Translate id="filters:destination" />
                  </div>
                  <div
                     onClick={() => toggle(false)}
                     className="absolute rtl:left-5 ltr:right-5 hover:cursor-pointer">
                     <CloseIconDark />
                  </div>
               </div>
               <motion.ul
                  className="list-none"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu">
                  {regions.map(({ slug, id, name, background_image }, idx) => (
                     <motion.div
                        // drag has to be done to ignore dragging this item so parent can be dragged :O
                        // in short terms, if this is not done, on phones, dragging the list wont close the sheet
                        key={id}
                        className="mb-4">
                        <li
                           className={styles['list-item']}
                           role="menuitem"
                           tabIndex={-1}
                           onClick={e => onItemClicked(slug, e.target as HTMLLIElement, idx)}>
                           <div className="flex items-center py-2 ">
                              <img
                                 // layout="fixed"
                                 className="object-cover w-10 h-10 rounded-full"
                                 src={background_image}
                                 alt="halayalla"
                                 width={40}
                                 height={40}
                              />
                              <span className="ltr:ml-5 rtl:mr-5 text-[17px]">{name}</span>
                           </div>
                        </li>
                     </motion.div>
                  ))}
               </motion.ul>
            </div>
         </BottomSheet>
      </Fragment>
   );
};

export default MobileDropdown;
